import React from "react";
import { useTimeAgo } from "../hooks/useTimeAgo";

export const FreshnessIndicator = ({ lastUpdated }) => {
	const timeAgo = useTimeAgo(lastUpdated);

	if (!lastUpdated) {
		return null;
	}

	// Data fetched within the last minute reads as "live".
	const isFresh = timeAgo === "just now";

	return (
		<output
			aria-live="polite"
			aria-label={`Data updated ${timeAgo}`}
			title={`Updated ${new Date(lastUpdated).toLocaleString()}`}
			className="hidden md:inline-flex items-center gap-1.5 text-xs font-medium tabular-nums leading-none text-[var(--surface-elevated-muted)] whitespace-nowrap select-none"
		>
			<span className="relative flex h-1.5 w-1.5">
				{isFresh && (
					<span className="absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-60 motion-safe:animate-ping" />
				)}
				<span
					className={`relative inline-flex h-1.5 w-1.5 rounded-full transition-colors duration-500 ${
						isFresh
							? "bg-emerald-500"
							: "bg-[var(--color-text-tertiary)] opacity-50"
					}`}
				/>
			</span>
			{timeAgo}
		</output>
	);
};
